import { styled, SxProps, Typography } from '@mui/material'
import { useTheme } from 'styled-components'
import { NoticeList } from '../PassRegister'

const Notice = ({
	title,
	caution,
	layoutStyle,
}: {
	title: string
	caution: Array<string> | string
	layoutStyle?: SxProps
}) => {
	const theme = useTheme()
	const isArray = Array.isArray(caution)
	return (
		<NoticeStack sx={layoutStyle}>
			<Typography variant="semibold12" sx={{ color: `${theme.new.colors.sol_gray_500}` }}>
				{title}
			</Typography>

			<NoticeList>
				{isArray ? (
					caution.map((item, index) => (
						<li key={index}>
							<Typography variant="regular12">{item}</Typography>
						</li>
					))
				) : (
					<Typography
						variant="regular12"
						color={(theme) => theme.palette.text.secondary}
						sx={{ whiteSpace: 'pre-wrap' }}>
						{caution}
					</Typography>
				)}
			</NoticeList>
		</NoticeStack>
	)
}

const NoticeStack = styled('div')(({ theme }) => ({
	position: 'relative',
	overflow: 'auto',
	padding: '12px',
	backgroundColor: theme.palette.grey['0'],
	borderRadius: '6px',
	maxHeight: '90px',
	'&::-webkit-scrollbar': {
		width: '4px',
	},

	'&::-webkit-scrollbar-thumb': {
		borderRadius: '2px',
		background: '#bbbbbf',
	},
}))

export default Notice
